'use strict';

angular.module('app.footer', [
    'sharecrf-url',
]);
